"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var angular = require("angular");
require('./recycle-bin.component.css');
var COMPONENT_NAME = 'smartorg.r6.navs.tree.recycleBin';
var RecycleBinComponent = /** @class */ (function () {
    function RecycleBinComponent($scope, $timeout) {
        var _this = this;
        this.$timeout = $timeout;
        $scope.$on('recycle-bin:init', function () {
            if (_this.selectedNodeId) {
                _this.errorMessages = [];
                _this.initiateDisplay();
            }
        });
    }
    RecycleBinComponent.prototype.initiateDisplay = function () {
        var _this = this;
        this.loading = true;
        return this.smartorgApi.listRecycleBin(this.selectedNodeId).then(function (rows) {
            _this.generateGridOptions(rows);
            _this.loading = false;
            _this.$timeout();
        })["catch"](function (err) {
            alert('Get list failed!');
            console.log(err);
        });
    };
    RecycleBinComponent.prototype.process = function (apiCall) {
        return __awaiter(this, void 0, void 0, function () {
            var rows, _i, rows_1, row, nodeId, _a, status_1, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.gridOptions || !this.gridOptions.data) {
                            return [2 /*return*/];
                        }
                        rows = this.gridOptions.data;
                        this.errorMessages = [];
                        _i = 0, rows_1 = rows;
                        _b.label = 1;
                    case 1:
                        if (!(_i < rows_1.length)) return [3 /*break*/, 4];
                        row = rows_1[_i];
                        nodeId = row._id;
                        if (!row.checked) return [3 /*break*/, 3];
                        return [4 /*yield*/, apiCall(this, this.selectedNodeId, nodeId)];
                    case 2:
                        _a = _b.sent(), status_1 = _a.status, error = _a.error;
                        if (status_1 > 0) {
                            this.errorMessages.push({ node: row.nodeName, error: error });
                        }
                        _b.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        this.processing = 0;
                        return [2 /*return*/, true];
                }
            });
        });
    };
    RecycleBinComponent.prototype.recover = function () {
        var _this = this;
        this.processing = 1;
        this.$timeout(function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.process(this.callRecoverApi)];
                    case 1:
                        if (_a.sent()) {
                            this.initiateDisplay();
                            this.postRecoverCallback();
                        }
                        return [2 /*return*/];
                }
            });
        }); });
    };
    RecycleBinComponent.prototype.callRecoverApi = function (scope, selectedNodeId, recordId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, scope.smartorgApi.recoverFromRecycle(selectedNodeId, recordId)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        return [2 /*return*/, { status: err_1.status, error: err_1.message }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RecycleBinComponent.prototype.permanentDelete = function () {
        var _this = this;
        var ctrl = this;
        bootbox.dialog({
            message: "You are about to permanently delete the checked nodes, their data, and all of their history. You cannot undo this action.",
            title: 'Confirm Deletion',
            buttons: {
                confirm: {
                    label: 'Delete',
                    className: 'btn-danger',
                    callback: function () {
                        ctrl.processing = 2;
                        ctrl.$timeout(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, ctrl.process(ctrl.callPermanentDeleteApi)];
                                    case 1:
                                        if (_a.sent()) {
                                            ctrl.initiateDisplay();
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    }
                },
                cancel: {
                    label: 'Cancel',
                    className: 'btn-primary'
                }
            }
        });
    };
    RecycleBinComponent.prototype.callPermanentDeleteApi = function (scope, selectedNodeId, recordId) {
        return __awaiter(this, void 0, void 0, function () {
            var err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, scope.smartorgApi.permanentDeleteRecord(selectedNodeId, recordId)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_2 = _a.sent();
                        return [2 /*return*/, { status: err_2.status, error: err_2.message }];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    RecycleBinComponent.prototype.cancel = function () {
        this.onCancel();
    };
    RecycleBinComponent.prototype.updateCheck = function () {
        this.somethingChecked = this.gridOptions.data.some(function (d) { return d.checked; }) && true;
    };
    RecycleBinComponent.prototype.generateGridOptions = function (rows) {
        var checkboxCell = '<div class="ui-grid-cell-contents" ' +
            'style="text-align: center" title="TOOLTIP">' +
            '<input type="checkbox" class="row-checkbox" ' +
            'ng-model="row.entity.checked" ' +
            'ng-change="grid.appScope.$ctrl.updateCheck()" />' +
            '</div>';
        var nodeTypeCell = '<div class="ui-grid-cell-contents" ' +
            'style="text-align: center" title="TOOLTIP">' +
            '<i ng-if="COL_FIELD === \'platform\'" class="fa fa-book node-type"></i>' +
            '<i ng-if="COL_FIELD === \'portfolio\'" class="fa fa-folder node-type"></i>' +
            '<i ng-if="COL_FIELD === \'leaf\'" class="fa fa-file-o node-type"></i>' +
            '&nbsp;({{row.entity.nodes.length}})' +
            '</div>';
        var checkCol = {
            field: 'checked',
            displayName: '',
            width: '30',
            enableSorting: false,
            enableFiltering: false,
            cellTemplate: checkboxCell
        };
        var nodeTypeCol = {
            field: 'nodeType',
            displayName: '',
            width: '60',
            enableSorting: false,
            enableFiltering: false,
            cellTemplate: nodeTypeCell
        };
        var colDef = [
            checkCol,
            nodeTypeCol,
            { field: 'nodeName', displayName: 'Node', width: '200' },
            { field: 'breadcrumb', displayName: 'Path', width: '360', cellClass: 'reverse-ellipsis' },
            { field: 'deleteTime', displayName: 'Time of Deletion', width: '200' },
            { field: 'deleteBy', displayName: 'Deleted By', width: '100' },
        ];
        this.gridOptions = {
            enableSorting: true,
            enableFiltering: false,
            showTreeExpandNoChildren: false,
            columnDefs: colDef,
            data: rows
        };
    };
    return RecycleBinComponent;
}());
exports.RecycleBinComponent = RecycleBinComponent;
angular.module(COMPONENT_NAME, [
    'ui.grid',
    'ui.grid.pinning',
    'ui.grid.resizeColumns',
    'ui.grid.autoResize',
    'ui.grid.treeView',
]).component('nodeRecycleBin', {
    template: require('./recycle-bin.component.html'),
    bindings: {
        selectedNodeId: '<',
        smartorgApi: '=',
        onCancel: '&',
        postRecoverCallback: '&'
    },
    controller: RecycleBinComponent
});
exports["default"] = COMPONENT_NAME;
//# sourceMappingURL=recycle-bin.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/tree/recycle-bin/recycle-bin.component.js